import { AxiosResponse } from "axios";
import fileSaver from "file-saver";

// before use this, api response type need to change to blob
export default function downloadXLS(response: AxiosResponse<any>) {
  const fileName = response.headers["content-disposition"].replace("attachment; filename*=utf-8''", "");
  fileSaver.saveAs(response.data, decodeURIComponent(fileName));
}
